<template>
  <div :class="$globalStyle.modalOverlay" v-if="isAuthModalOpen">
    <div :class="[$style.authModalContent]" @click.stop>
      <div :class="$style.modalHeader">
        <div :class="$style.emptyBtn"></div>
        <div :class="$style.titleSection">
          <div :class="$style.title">
            <template v-if="authModalMode === 'login'">{{ $t('login') }}</template>
            <template v-else-if="authModalMode === 'signup'">{{ $t('sign-up') }}</template>
            <template v-else-if="authModalMode === 'forgotPassword'">Reset Password</template>
          </div>
        </div>
        <div :class="$style.closeBtn">
          <UtilButton
            :clickFunction="closeModal"
            backBg="#A50000"
            frontBg="#F77575"
            textColor="#FFFFFF"
            :iconLink="closeIcon"
            :iconOnly="true"
            size="xs"
          />
        </div>
      </div>
      <div :class="$style.modalBody">
        <div :class="$style.formSection">
          <div :class="$style.form">
            <template v-if="authModalMode === 'login'">
              <div :class="$style.instruction">{{ $t('email-password') }}</div>
            </template>
            <template v-if="authModalMode === 'signup'">
              <template v-if="signupPhase === 'email'">
                <div :class="$style.instruction">{{ $t('email-please') }}</div>
              </template>
              <template v-if="signupPhase === 'details'">
                <div :class="$style.instruction">{{ $t('enter-details') }}</div>
              </template>
              <template v-if="signupPhase === 'confirm'">
                <div :class="$style.instruction">
                  Please enter the confirmation code sent to <i>{{ form.email }}</i>
                </div>
              </template>
            </template>
            <template v-if="authModalMode === 'forgotPassword'">
              <template v-if="forgotPasswordPhase === 'email'">
                <div :class="$style.instruction">Please enter your email to reset your password</div>
              </template>
              <template v-if="forgotPasswordPhase === 'confirm'">
                <div :class="$style.instruction">
                  Please enter the confirmation code sent to <i>{{ form.email }}</i>
                </div>
              </template>
              <template v-if="forgotPasswordPhase === 'newPassword'">
                <div :class="$style.instruction">Please create a new password</div>
              </template>
              <template v-if="forgotPasswordPhase === 'success'">
                <div :class="$style.instruction">
                  Successfully created a new password. You can now login using your new password!
                </div>
              </template>
            </template>
            <template v-if="authModalMode === 'login'">
              <AuthModalInput
                label="Email"
                :iconLink="emailIcon"
                :placeholder="$t('enter-email')"
                :value="form.email"
                inputType="email"
                @update:value="form.email = $event"
              />
              <AuthModalInput
                label="Password"
                :iconLink="passwordIcon"
                :placeholder="$t('enter-password')"
                :value="form.password"
                inputType="password"
                @update:value="form.password = $event"
              />
              <span :class="$style.forgotPassLink" @click="forgotPassword">{{ $t('forgot-password') }}</span>
            </template>
            <template v-if="authModalMode === 'signup'">
              <template v-if="signupPhase === 'email'">                  
                <AuthModalInput
                  :label="$t('email')"
                  :iconLink="emailIcon"
                  placeholder="Enter your email here ..."
                  :value="form.email"
                  inputType="email"
                  @update:value="form.email = $event"
                />
              </template>
              <template v-else-if="signupPhase === 'details'">
                <AuthModalInput
                  :label="$t('first-name')"
                  :placeholder="$t('enter-first-name')"
                  :value="form.firstName"
                  inputType="text"
                  @update:value="form.firstName = $event"
                />
                <AuthModalInput
                  :label="$t('last-name')"
                  :placeholder="$t('enter-last-name')"
                  :value="form.lastName"
                  inputType="text"
                  @update:value="form.lastName = $event"
                />
                <AuthModalInput
                  :label="$t('password')"
                  :placeholder="$t('enter-password')"
                  :value="form.password"
                  inputType="password"
                  @update:value="form.password = $event"
                />
                <AuthModalInput
                  :label="$t('confirm-password')"
                  :placeholder="$t('re-enter-password')"
                  :value="form.confirmPassword"
                  inputType="password"
                  @update:value="form.confirmPassword = $event"
                />
                <label :class="$style.emailLanguageField">
                  <span :class="$style.emailLanguageLabel">Email language</span>
                  <select v-model="form.emailLanguage" :class="$style.emailLanguageSelect">
                    <option
                      v-for="language in signupEmailLanguages"
                      :key="language.value"
                      :value="language.value"
                    >
                      {{ language.label }}
                    </option>
                  </select>
                </label>
              </template>
              <template v-else-if="signupPhase === 'confirm'">
                <AuthModalInput
                  :label="$t('confirm-code')"
                  :placeholder="$t('enter-confirm-code')"
                  :value="form.code"
                  inputType="text"
                  @update:value="form.code = $event"
                />
              </template>
            </template>
            <template v-if="authModalMode === 'forgotPassword'">
              <template v-if="forgotPasswordPhase === 'email'">
                <AuthModalInput
                  :label="$t('email')"
                  :iconLink="emailIcon"
                  :placeholder="$t('enter-email')"
                  :value="form.email"
                  inputType="email"
                  @update:value="form.email = $event"
                />
              </template>
              <template v-else-if="forgotPasswordPhase === 'newPassword'">
                <AuthModalInput
                  label="New Password"
                  placeholder="Enter your new password here ..."
                  :value="form.password"
                  inputType="password"
                  @update:value="form.password = $event"
                />
                <AuthModalInput
                  label="Confirm New Password"
                  placeholder="Re-enter your new password here ..."
                  :value="form.confirmPassword"
                  inputType="password"
                  @update:value="form.confirmPassword = $event"
                />
              </template>
              <template v-else-if="forgotPasswordPhase === 'confirm'">
                <AuthModalInput
                  :label="$t('confirm-code')"
                  :placeholder="$t('enter-confirm-code')"
                  :value="form.code"
                  inputType="text"
                  @update:value="form.code = $event"
                />
              </template>
              <template v-else-if="forgotPasswordPhase === 'success'"></template>
            </template>
          </div>
          <div :class="$style.authCTA">
            <template v-if="authModalMode === 'login'">
              <ActionButton
                :text="$t('login')"
                :clickFunction="handleLogin"
                backBg="#000000"
                frontBg="#676767"
                textColor="#FFFFFF"
                :rightIcon="true"
                buttonWidth="clamp(120px, 15vw, 160px)"
              />
            </template>
            <template v-if="authModalMode === 'signup'">
              <template v-if="signupPhase === 'email'">
                <ActionButton
                  :text="$t('continue')"
                  :clickFunction="handleEmailCheck"
                  backBg="#000000"
                  frontBg="#676767"
                  textColor="#FFFFFF"
                  :rightIcon="true"
                  buttonWidth="clamp(160px, 15vw, 180px)"
                />
              </template>
              <template v-else-if="signupPhase === 'details'">
                <ActionButton
                  :text="$t('continue')"
                  :clickFunction="handleDetailsCheck"
                  backBg="#000000"
                  frontBg="#676767"
                  textColor="#FFFFFF"
                  :rightIcon="true"
                  buttonWidth="clamp(160px, 15vw, 180px)"
                />
              </template>
              <template v-else>
                <ActionButton
                  :text="$t('confirm')"
                  :clickFunction="handleCodeCheck"
                  backBg="#000000"
                  frontBg="#676767"
                  textColor="#FFFFFF"
                  :rightIcon="true"
                  buttonWidth="clamp(160px, 15vw, 180px)"
                />
              </template>
            </template>
            <template v-if="authModalMode === 'forgotPassword'">
              <template v-if="forgotPasswordPhase === 'email'">
                <ActionButton
                  :text="$t('continue')"
                  :clickFunction="handleFPEmailCheck"
                  backBg="#000000"
                  frontBg="#676767"
                  textColor="#FFFFFF"
                  :rightIcon="true"
                  buttonWidth="clamp(160px, 15vw, 180px)"
                />
              </template>
              <template v-else-if="forgotPasswordPhase === 'newPassword'">
                <ActionButton
                  :text="$t('continue')"
                  :clickFunction="handleFPPasswordCheck"
                  backBg="#000000"
                  frontBg="#676767"
                  textColor="#FFFFFF"
                  :rightIcon="true"
                  buttonWidth="clamp(160px, 15vw, 180px)"
                />
              </template>
              <template v-else-if="forgotPasswordPhase === 'confirm'">
                <ActionButton
                  :text="$t('confirm')"
                  :clickFunction="handleFPCodeCheck"
                  backBg="#000000"
                  frontBg="#676767"
                  textColor="#FFFFFF"
                  :rightIcon="true"
                  buttonWidth="clamp(160px, 15vw, 180px)"
                />
              </template>
              <template v-else-if="forgotPasswordPhase === 'success'">
                <ActionButton
                  :text="$t('login')"
                  :clickFunction="handleFPLogin"
                  backBg="#000000"
                  frontBg="#676767"
                  textColor="#FFFFFF"
                  :rightIcon="true"
                  buttonWidth="clamp(120px, 15vw, 160px)"
                />
              </template>
            </template>
          </div>
          <div
            v-if="
              (authModalMode === 'signup' && signupPhase === 'confirm') ||
              (authModalMode === 'forgotPassword' && forgotPasswordPhase === 'confirm')
            "
            :class="$style.resendCodeSection"
          >
            {{ $t('no-code') }}
            <span v-if="resendCodeTimer > 0" :class="$style.resendCodeTimer"> ({{ resendCodeTimer }}s)</span>
            <span
              v-else
              :class="$style.resendCodeLink"
              @click="authModalMode === 'signup' ? resendCode() : resendFPCode()"
              >Resend</span
            >
          </div>
          <div :class="$style.errorMessage">
            {{ errorMessage }}
          </div>
        </div>
        <div :class="$style.authSwitchSection">
          <template v-if="authModalMode === 'forgotPassword'">
            <span :class="$style.authSwitchLink" @click="() => toggleAuthMode('login')">{{ $t('login') }}</span> |
            <span :class="$style.authSwitchLink" @click="() => toggleAuthMode('signup')">{{ $t('sign-up') }}</span>
          </template>
          <template v-else>
            <template v-if="authModalMode === 'login'">
              {{ $t('no-account') }}
              <span :class="$style.authSwitchLink" @click="() => toggleAuthMode('signup')">{{ $t('sign-up') }}</span>
            </template>
            <template v-else>
              {{ $t('have-account') }}
              <span :class="$style.authSwitchLink" @click="() => toggleAuthMode('login')">{{ $t('login') }}</span>
            </template>
          </template>
        </div>
      </div>
      <div v-if="isLoading" :class="$style.modalLoaderContainer">
        <img :src="loaderGif" alt="auth-loading-gif" :class="$style.modalLoaderGif" />
        <!-- <div class="auth-loading-text">Loading</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/authStore";
import { useAppStore } from "@/stores/appStore";
import { storeToRefs } from "pinia";
import globalStyles from "@/css/global.module.css";
import styles from "@/css/AuthModal.module.css";
import EmailIcon from "@/assets/icons/email-black.svg";
import PasswordIcon from "@/assets/icons/password-black.svg";
import NameTagIcon from "@/assets/icons/name-tag.svg";
import CloseIcon from "@/assets/icons/close-white.svg";
import UtilButton from "../util/UtilButton.vue";
import gameService from "@/services/game.service";
import LoaderGif from "@/assets/gifs/app-loader.svg";
import { toast } from "vue3-toastify";
import AuthModalInput from "./AuthModalInput.vue";
import ActionButton from "../buttons/ActionButton.vue";
import { getPostAuthLandingRoute } from "@/utils/permissions";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/; // At least 8 characters, at least one letter, one number, and one special caracter
const nameRegex = /^[a-zA-Z]+$/; // Only letters
const DEFAULT_EMAIL_LANGUAGE = "en";
const SIGNUP_EMAIL_LANGUAGES = [
  { value: "en", label: "English" },
  { value: "es", label: "Spanish" },
  { value: "fr", label: "French" },
  { value: "ar", label: "Arabic" },
  { value: "zh-Hans", label: "Chinese Simplified" },
  { value: "zh-Hant", label: "Chinese Traditional" },
  { value: "hi", label: "Hindi" },
  { value: "bn", label: "Bengali" },
  { value: "pt", label: "Portuguese" },
  { value: "ru", label: "Russian" },
  { value: "ja", label: "Japanese" },
  { value: "ko", label: "Korean" },
  { value: "de", label: "German" },
  { value: "it", label: "Italian" },
  { value: "tr", label: "Turkish" },
  { value: "vi", label: "Vietnamese" },
  { value: "id", label: "Indonesian" },
  { value: "ur", label: "Urdu" },
  { value: "fa", label: "Persian" },
  { value: "pl", label: "Polish" },
  { value: "nl", label: "Dutch" },
  { value: "uk", label: "Ukrainian" },
  { value: "th", label: "Thai" },
  { value: "fil", label: "Filipino" },
  { value: "sw", label: "Swahili" },
  { value: "sr", label: "Serbian" },
  { value: "hr", label: "Croatian" },
  { value: "bs", label: "Bosnian" },
  { value: "sq", label: "Albanian" },
  { value: "el", label: "Greek" },
  { value: "bg", label: "Bulgarian" },
  { value: "ro", label: "Romanian" },
  { value: "mk", label: "Macedonian" },
  { value: "sl", label: "Slovenian" },
  { value: "hu", label: "Hungarian" },
  { value: "az", label: "Azerbaijani" },
];

export default {
  name: "AuthModal",
  components: { UtilButton, AuthModalInput, ActionButton },
  data() {
    return {
      isLoading: false,
      loaderGif: LoaderGif,
      emailIcon: EmailIcon,
      passwordIcon: PasswordIcon,
      nameTagIcon: NameTagIcon,
      closeIcon: CloseIcon,
      signupEmailLanguages: SIGNUP_EMAIL_LANGUAGES,
      signupPhase: "email", // 'email', 'details', 'confirm' // @TODO: change
      forgotPasswordPhase: "email", // 'email', 'confirm', 'newPassword' // @TODO: change
      errorMessage: "",
      form: {
        email: "",
        password: "",
        confirmPassword: "",
        firstName: "",
        lastName: "",
        code: "",
        emailLanguage: DEFAULT_EMAIL_LANGUAGE,
      },
      resendCodeTimer: 0,
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $globalStyle() {
      return globalStyles;
    },
  },
  methods: {
    closeModal() {
      this.resetAuthForm(); // Reset form fields
      this.signupPhase = "email"; // Reset to initial phase
      this.forgotPasswordPhase = "email"; // Reset forgot password phase
      this.errorMessage = ""; // Reset error message

      this.authStore.closeAuthModal();
    },
    async handleLogin() {
      // console.log("Login clicked", this.form.email, this.form.password);
      this.errorMessage = ""; // Reset error message

      if (this.form.email === "") {
        this.errorMessage = "Please enter email.";
        return;
      }

      if (!emailRegex.test(this.form.email)) {
        this.errorMessage = "Please enter a valid email address.";
        return;
      }

      if (this.form.password === "") {
        this.errorMessage = "Please enter password.";
        return;
      }

      // @TODO: make API call to login
      try {
        // this.appStore.showAppLoader();
        this.isLoading = true; // Show loading state

        const payLoad = {
          email: this.form.email,
          password: this.form.password,
        };
        // console.log("Payload for login:", payLoad);
        const res = await gameService.loginUser(payLoad);
        // console.log("Response from login API:", res);

        // Check for HTTP error status
        if (res.status === 200) {
          var user = {
            id: res.data.id,
            email: res.data.email,
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            isTeacher: res.data.isTeacher,
            isAdmin: res.data.isAdmin !== undefined ? res.data.isAdmin : 0,
            isResearcher: res.data.isResearcher !== undefined ? res.data.isResearcher : false,
          };

          this.authStore.login(res.data.accessToken, user);
          toast("Successfully logged in!", {
            type: "success",
          });
          this.closeModal();
          this.redirectAfterAuth(user);
        } else if ([400, 404].includes(res.status)) {
          if (res.data.error) {
            console.error(res.data.error);
          }

          this.errorMessage = res.data.message || "Unexpected error. Please try again.";
        } else {
          var error = res.data.error || "Unknown error occurred";
          console.error("Error logging in user:", error);
          this.errorMessage = "Unexpected error. Please try again.";
        }
      } catch (error) {
        console.error("Error logging in user:", error);
        this.errorMessage = "Unexpected error. Please try again.";
      } finally {
        // this.appStore.hideAppLoader();
        this.isLoading = false;
      }
    },
    toggleAuthMode(mode = "signup") {
      // console.log("Toggle auth mode clicked - mode: ", mode);
      // this.authStore.toggleAuthModalMode();
      this.authStore.changeAuthModalMode(mode);

      // @TODO: Reset form fields when switching between login and signup
      // @TOOD: Reset signup phase
      this.resetAuthForm(); // Reset form fields
      this.signupPhase = "email"; // Reset to initial phase // @TODO: change
      this.forgotPasswordPhase = "email"; // Reset forgot password phase
      this.errorMessage = ""; // Reset error message
      this.resendCodeTimer = 0; // Reset resend code timer
    },
    resetAuthForm() {
      this.form.email = "";
      this.form.password = "";
      this.form.confirmPassword = "";
      this.form.firstName = "";
      this.form.lastName = "";
      this.form.code = "";
      this.form.emailLanguage = DEFAULT_EMAIL_LANGUAGE;
    },
    redirectAfterAuth(user) {
      const landingRoute = getPostAuthLandingRoute(user);
      if (landingRoute) {
        this.$router.push(landingRoute);
      }
    },
    // handleSingup() {
    //   console.log("Sign Up clicked");
    // },
    async handleEmailCheck() {
      // console.log("Continue clicked", this.form.email);

      this.errorMessage = ""; // Reset error message

      if (this.form.email === "") {
        this.errorMessage = "Please enter email.";
        return;
      }

      if (!emailRegex.test(this.form.email)) {
        this.errorMessage = "Please enter a valid email address.";
        return;
      }

      // @TODO: make API call to check email
      try {
        this.isLoading = true;

        const payLoad = {
          email: this.form.email,
        };
        // console.log("Payload for verifySignupEmail:", payLoad);
        const res = await gameService.verifySignupEmail(payLoad);
        // console.log("Response from verifySignupEmail API:", res);

        // Check for HTTP error status
        if (res.status === 200) {
          if ("isExistingUser" in res.data) {
            if (res.data.isExistingUser) {
              this.errorMessage = "Email already exists. Please try logging in.";
              return;
            }

            // Email does not exist, proceed to next phase
            this.signupPhase = "details";
          } else {
            this.errorMessage = "Unexpected response from server. Please try again.";
            return;
          }
        } else if ([400, 404].includes(res.status)) {
          if (res.data.error) {
            console.error(res.data.error);
          }

          this.errorMessage = res.data.message || "Unexpected response from server. Please try again.";
        } else {
          var error = res.data.error || "Unknown error occurred";
          console.error("Error verifying user email:", error);
          this.errorMessage = "Unexpected response from server. Please try again.";
        }
      } catch (error) {
        console.error("Error verifying user email:", error);
        this.errorMessage = "Unexpected response from server. Please try again.";
      } finally {
        this.isLoading = false;
      }
    },
    async handleFPEmailCheck() {
      // console.log("Continue clicked", this.form.email);

      this.errorMessage = ""; // Reset error message

      if (this.form.email === "") {
        this.errorMessage = "Please enter email.";
        return;
      }

      if (!emailRegex.test(this.form.email)) {
        this.errorMessage = "Please enter a valid email address.";
        return;
      }

      // console.log("Checking email for forgot password");

      try {
        this.isLoading = true;

        const payLoad = {
          email: this.form.email,
        };
        // console.log("Payload for verifyFPEmail:", payLoad);
        const res = await gameService.verifyFPEmail(payLoad);
        // console.log("Response from verifyFPEmail API:", res);

        if (res.status === 200) {
          if ("isExistingUser" in res.data) {
            if (res.data.isExistingUser) {
              this.forgotPasswordPhase = "newPassword"; // Move to confirm phase
            } else {
              this.errorMessage = "Email does not exists. Please try signing up.";
            }
          } else {
            this.errorMessage = "Unexpected response from server. Please try again.";
          }
        } else if ([400, 404].includes(res.status)) {
          if (res.data.error) {
            console.error(res.data.error);
          }

          this.errorMessage = res.data.message || "Unexpected response from server. Please try again.";
        } else {
          var error = res.data.error || "Unknown error occurred";
          console.error("Error verifying user email:", error);
          this.errorMessage = "Unexpected response from server. Please try again.";
        }
      } catch (error) {
        console.error("Error verifying user email:", error);
        this.errorMessage = "Unexpected response from server. Please try again.";
      } finally {
        this.isLoading = false; // Hide loading state
      }
    },
    async handleDetailsCheck() {
      // console.log("Continue clicked", this.form.firstName, this.form.lastName);

      this.errorMessage = ""; // Reset error message

      if (this.form.firstName === "") {
        this.errorMessage = "Please enter first name.";
        return;
      }

      if (!nameRegex.test(this.form.firstName)) {
        this.errorMessage = "Please enter a valid first name.";
        return;
      }

      if (this.form.lastName === "") {
        this.errorMessage = "Please enter last name.";
        return;
      }

      if (!nameRegex.test(this.form.lastName)) {
        this.errorMessage = "Please enter a valid last name.";
        return;
      }

      if (this.form.password === "") {
        this.errorMessage = "Please enter password.";
        return;
      }

      if (!passwordRegex.test(this.form.password)) {
        this.errorMessage =
          "Please enter a valid password. It should be at least 8 characters long and contain at least one letter, one number, and one special character.";
        return;
      }

      if (this.form.confirmPassword === "") {
        this.errorMessage = "Please confirm password.";
        return;
      }

      if (this.form.password !== this.form.confirmPassword) {
        this.errorMessage = "Passwords do not match.";
        return;
      }

      // @TODO: make API call to send confirmation code
      var actionResult = await this.sendVerificationCode();
      if (!actionResult) {
        // If the API call failed, show error message
        // @see: already showing the erro message in the function
        // this.errorMessage = "Unable to send verification code. Please try again.";
        return;
      }

      // Verification code sent, proceed to next phase
      this.signupPhase = "confirm";
    },
    async handleCodeCheck() {
      this.errorMessage = ""; // Reset error message

      if (this.form.code === "") {
        this.errorMessage = "Please enter the confirmation code.";
        return;
      }

      // console.log("Confirm clicked", this.form.code);

      // @TODO: make API call to check confirmation code
      try {
        this.isLoading = true;

        const payLoad = {
          code: this.form.code,
          email: this.form.email,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          password: this.form.password,
        };
        // console.log("Payload for signupVerifyCode:", payLoad);
        const res = await gameService.signupVerifyCode(payLoad);
        // console.log("Response from signupVerifyCode API:", res);

        // Check for HTTP error status
        if (res.status === 200) {
          var user = {
            id: res.data.id,
            email: res.data.email,
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            isTeacher: res.data.isTeacher,
            isAdmin: res.data.isAdmin !== undefined ? res.data.isAdmin : 0,
            isResearcher: res.data.isResearcher !== undefined ? res.data.isResearcher : false,
          };

          this.authStore.login(res.data.accessToken, user);

          // show toast or notification for successful signup
          toast("Successfully signed up!", {
            type: "success",
          });

          this.closeModal(); // Close the modal after successful signup
          this.redirectAfterAuth(user);
        } else if ([400, 404, 409, 429, 500].includes(res.status)) {
          if (res.data.error) {
            console.error(res.data.error);
          }

          this.errorMessage = res.data.message || "Unable to check verification code. Please try again.";
        } else {
          var error = res.data.error || "Unknown error occurred";
          console.error("Error sending verification code:", error);
          this.errorMessage = "Unable to check verification code. Please try again.";
        }
      } catch (error) {
        console.error("Error sending verification code:", error);
        this.errorMessage = "Unable to check verification code. Please try again.";
      } finally {
        this.isLoading = false; // Hide loading state
      }
    },
    async handleFPCodeCheck() {
      // console.log("Confirm clicked", this.form.code);

      this.errorMessage = ""; // Reset error message

      if (this.form.code === "") {
        this.errorMessage = "Please enter the confirmation code.";
        return;
      }

      // console.log("Checking confirmation code for forgot password");

      try {
        this.isLoading = true;

        const payLoad = {
          code: this.form.code,
          email: this.form.email,
          password: this.form.password,
        };
        // console.log("Payload for fPVerifyCode:", payLoad);
        const res = await gameService.fPVerifyCode(payLoad);
        // console.log("Response from fPVerifyCode API:", res);

        // Check for HTTP error status
        if (res.status === 200) {
          // Password reset successful, show success message
          // Proceed to the next phase to show success message
          this.forgotPasswordPhase = "success";
        } else if ([400, 404, 409, 429, 500].includes(res.status)) {
          if (res.data.error) {
            console.error(res.data.error);
          }

          this.errorMessage = res.data.message || "Unable to check verification code. Please try again.";
        } else {
          var error = res.data.error || "Unknown error occurred";
          console.error("Error checking verification code:", error);
          this.errorMessage = "Unable to check verification code. Please try again.";
        }
      } catch (error) {
        console.error("Error checking verification code:", error);
        this.errorMessage = "Unable to check verification code. Please try again.";
      } finally {
        this.isLoading = false; // Hide loading state
      }
    },
    async handleFPPasswordCheck() {
      this.errorMessage = ""; // Reset error message

      if (this.form.password === "") {
        this.errorMessage = "Please enter password.";
        return;
      }

      if (!passwordRegex.test(this.form.password)) {
        this.errorMessage =
          "Please enter a valid password. It should be at least 8 characters long and contain at least one letter, one number, and one special character.";
        return;
      }

      if (this.form.confirmPassword === "") {
        this.errorMessage = "Please confirm password.";
        return;
      }

      if (this.form.password !== this.form.confirmPassword) {
        this.errorMessage = "Passwords do not match.";
        return;
      }

      // console.log("New password clicked", this.form.password);
      var actionResult = await this.sendFPVerificationCode();
      if (!actionResult) {
        return;
      }

      this.forgotPasswordPhase = "confirm"; // Move to confirm phase
    },
    handleFPLogin() {
      // this.authModalMode = "login"; // Switch to login mode
      this.authStore.changeAuthModalMode("login");
      this.resetAuthForm(); // Reset form fields
      this.signupPhase = "email"; // Reset to initial phase
      this.forgotPasswordPhase = "email"; // Reset forgot password phase
      this.errorMessage = ""; // Reset error message
    },
    async sendFPVerificationCode() {
      // console.log("Send FP verification code clicked");
      var actionResult = false; // Initialize action result

      try {
        this.isLoading = true;

        const payLoad = {
          email: this.form.email,
        };
        // console.log("Payload for sendFPVerificationCode:", payLoad);
        const res = await gameService.sendFPVerificationCode(payLoad);
        // console.log("Response from sendFPVerificationCode API:", res);

        // Check for HTTP error status
        if (res.status === 200) {
          // verification code sent
          // start 60 sec timer
          this.resendCodeTimer = 60;
          const interval = setInterval(() => {
            if (this.resendCodeTimer > 0) {
              this.resendCodeTimer--;
            } else {
              clearInterval(interval);
            }
          }, 1000);
          this.errorMessage = ""; // Reset error message

          actionResult = true; // Indicate success
        } else if ([400, 409, 429, 500].includes(res.status)) {
          if (res.data.error) {
            console.error(res.data.error);
          }

          this.errorMessage = res.data.message || "Unable to send verification code. Please try again.";
        } else {
          var error = res.data.error || "Unknown error occurred";
          console.error("Error sending verification code:", error);
          this.errorMessage = "Unable to send verification code. Please try again.";
        }
      } catch (error) {
        console.error("Error sending verification code:", error);
        this.errorMessage = "Unable to send verification code. Please try again.";
      } finally {
        this.isLoading = false;
      }

      return actionResult;
    },
    async sendVerificationCode() {
      // console.log("Send verification code clicked");
      var actionResult = false; // Initialize action result
      try {
        this.isLoading = true;

        const payLoad = {
          email: this.form.email,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          emailLanguage: this.form.emailLanguage || DEFAULT_EMAIL_LANGUAGE,
        };
        // console.log("Payload for sendSignupVerificationCode:", payLoad);
        const res = await gameService.sendSignupVerificationCode(payLoad);
        // console.log("Response from sendSignupVerificationCode API:", res);

        // Check for HTTP error status
        if (res.status === 200) {
          // verification code sent
          // start 60 sec timer
          this.resendCodeTimer = 60;
          const interval = setInterval(() => {
            if (this.resendCodeTimer > 0) {
              this.resendCodeTimer--;
            } else {
              clearInterval(interval);
            }
          }, 1000);
          this.errorMessage = ""; // Reset error message

          actionResult = true; // Indicate success
        } else if ([400, 409, 429, 500].includes(res.status)) {
          if (res.data.error) {
            console.error(res.data.error);
          }

          this.errorMessage = res.data.message || "Unable to send verification code. Please try again.";
        } else {
          var error = res.data.error || "Unknown error occurred";
          console.error("Error sending verification code:", error);
          this.errorMessage = "Unable to send verification code. Please try again.";
        }
      } catch (error) {
        console.error("Error sending verification code:", error);
        this.errorMessage = "Unable to send verification code. Please try again.";
      } finally {
        this.isLoading = false;
      }

      return actionResult;
    },
    async resendFPCode() {
      // console.log("Resend FP code clicked");
      var actionResult = await this.sendFPVerificationCode();

      if (!actionResult) {
        // If the API call failed, show error message
        // @see: already showing the erro message in the function
        // return;
      }
    },
    async resendCode() {
     //console.log("Resend code clicked");
      var actionResult = await this.sendVerificationCode();

      if (!actionResult) {
        // If the API call failed, show error message
        // @see: already showing the erro message in the function
        // return;
      }
    },
    forgotPassword() {
      // console.log("Forgot password clicked");
      this.authStore.changeAuthModalMode("forgotPassword");
    },
  },
  setup() {
    const authStore = useAuthStore();
    // @see: do not use storeToRefs here, as it will not work functions like closeAuthModal, toggleAuthModalMode, login
    const { isAuthModalOpen, authModalMode } = storeToRefs(authStore);

    const appStore = useAppStore();
    // const { isAppLoading } = storeToRefs(appStore);

    return {
      authStore,
      isAuthModalOpen,
      authModalMode,
      appStore,
    };
  },
};
</script>

<style></style>
